module.exports = __webpack_public_path__ + "static/img/logo.e8b3f874.png";